import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';

@Injectable()
export class InstallationDimensionPluginService extends InspectionPluginService {
  private measuringUnitsKeysKeys = [
    { value: 1, label: 'plugins.installationdimensions.meter' },
    { value: 2, label: 'plugins.installationdimensions.inch' },
    { value: 3, label: 'plugins.installationdimensions.foot' }
  ];

  private measuringUnits = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  getMeasuringUnits() {
    return this.measuringUnits;
  }

  public updateDimensions(inspectionId: string, pointId: string, pluginId: string, dimensions: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, dimensions).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private applyTranslations() {
    this.measuringUnits = [];
    this.copyTranslationValues(this.measuringUnitsKeysKeys, this.measuringUnits, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, dimensions: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, dimensions, 'Dimensions').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
